module.exports = __webpack_public_path__ + "static/media/background.81c0d587.png";